import { render, staticRenderFns } from "./KvListor.vue?vue&type=template&id=95c303d8&"
import script from "./KvListor.vue?vue&type=script&lang=js&"
export * from "./KvListor.vue?vue&type=script&lang=js&"
import style0 from "./KvListor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports